import React from 'react';
import './homepage.css';

const posts = [
  {
    title: 'Sustainable Weight Loss: GLP-1 Medications',
    date: 'March 3, 2025',
    excerpt: 'In the UK, prescription medications play a crucial role in managing health, whether they are issued by the NHS or private healthcare providers...',
    image: '/assets/new_assets/post_1.png',
    link: '/sustainable-weight-loss-glp-1-medications',
  },
  {
    title: 'The Importance of Blood Testing',
    date: 'March 3, 2025',
    excerpt: 'Blood testing is one of the most effective ways to monitor and manage your health. At My Private Chemist, we offer comprehensive blood testing...',
    image: '/assets/new_assets/post_2.png',
    link: '/the-importance-of-blood-testing',
  },
];

const BlogSection = () => {
  return (
    <section className="hp-blog">
      <div className="hp-blog__container">
        <div className="hp-blog__grid">
          {posts.map((post) => (
            <article className="hp-blog-card" key={post.title}>
              <a href={post.link}>
                <img
                  src={post.image}
                  alt={post.title}
                  className="hp-blog-card__img"
                />
              </a>
              <div className="hp-blog-card__body">
                <p className="hp-blog-card__date">
                  <span className="hp-blog-card__date-badge">{post.date}</span>
                </p>
                <a href={post.link} className="hp-blog-card__title">
                  {post.title}
                </a>
                <p className="hp-blog-card__desc">{post.excerpt}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;